import { useIsFetching } from '@tanstack/react-query';

/**
 * Полоса загрузки под шапкой.
 *
 * Показывает не первую загрузку — её показывают скелетоны на месте будущих
 * карточек, — а любой фоновый запрос: обновление после платежа, переход на
 * экран с закэшированными данными. Без неё приложение в такие моменты
 * выглядит замершим.
 */
export function Progress() {
  const fetching = useIsFetching();
  if (fetching === 0) return null;
  return <div className="progress" role="progressbar" aria-busy="true" />;
}
